<template>
    <div ref="diagram"></div>
</template>

<script>
import mermaid from 'mermaid';

mermaid.initialize({ startOnLoad: false, theme: 'default' });

export default {
    name: 'MermaidFlow',
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    watch: {
        value: {
            handler() {
                this.renderDiagram();
            },
            immediate: true,
        },
    },
    methods: {
        async renderDiagram() {
            if (!this.value) {
                return;
            }

            this.$emit('rendering');

            const diagramId = `mermaidFlow${Date.now()}`;
            try {
                const { svg } = await mermaid.render(diagramId, this.value);
                this.$refs.diagram.innerHTML = svg;
            } catch (err) {
                this.$refs.diagram.textContent =
                    err.message || 'Mermaid render error';
            }
            this.$emit('rendered');
        },
    },
};
</script>
